import { ModelCommon, UserAttributeDef, UserAttributeDefs, toDatePickerFormat, ValidModelType } from '@iotv/datamodel-core';
import { isValidBusinessObject, MapLike, PathDirection } from '@iotv/iotv-v3-types';

const typeName = 'IrrigationProgrammeUplinks';

export type IrrigationProgrammeUplinksProps = {
  // Payload, time, signal not needed?
};

export class IrrigationProgrammeUplinks extends ModelCommon {
  constructor(ob: any) {
    super(ob.type || typeName, ob);
  }

  // Payload, time, signal not needed?

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      Payload: {
        type: 'RelatedType',
        editable: false,
        label: 'payload',
        name: 'Payload',
        description: 'The raw payload ',
        objectTypeId: 'Water_Flow|P' as ValidModelType,
        direction: PathDirection.child,
        edgeTypeId: 'Irrigation_Programme_Uplinks_has_Payload_Water_Flow|P',
      },
      Time: {
        type: 'RelatedType',
        editable: false,
        label: 'time',
        name: 'Time',
        description: 'The time of the message (UTC)',
        objectTypeId: 'Farm_Area|P' as ValidModelType,
        direction: PathDirection.child,
        edgeTypeId: 'Irrigation_Programme_Uplinks_has_Time_Farm_Area|P',
      },
      Signal: {
        type: 'RelatedType',
        editable: false,
        label: 'signal',
        name: 'Signal',
        description: 'The signal strength of the message (If applicable)',
        objectTypeId: 'Irrigation_Readings|P' as ValidModelType,
        direction: PathDirection.child,
        edgeTypeId: 'Irrigation_Programme_Uplinks_has_Signal_Irrigation_Readings|P',
      },
    };
  };
}
